"use client";

import styles from "./index.module.css";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import RacingHeader from "@/app/ui/racingHeader";
import RacingInfo from "@/app/ui/racingInfo";
import Footer from "@/app/ui/footer";
import Box from "@mui/material/Box";
import RaceDetail from "@/app/ui/RaceDetail";
import { addSeasonYear, generateAdobeDataRaceNo, generateFormGuidePdfPath, orderRaceOnBizDateFromQIDS, getDefaultMenuTab, getSearchParams, isUrlExistedWithContentType, setRouting, theme, updateMetaTag, isBeforeCutoff, orderMtgWithMainRaceFromCMS, useInterval } from "@/app/utils/Common";
import { isValidDate, toDate, formattedDate, toDayJS, compareDate, dateFormat, minDate, withinDate } from "@/app/utils/DayJS";
import { useMediaQuery } from "@mui/material";
import Broadcast from "@/app/ui/broadcast";
import { useEffect, useState } from "react";
import { getBusinessDate, getHomeBasicInfo, getMeetingStatus, getOverrideRedirectionConfig, getSelectedMeetingInfo, searchMeetingsByDate, searchMeetingsInDateRange, getupcomingRacecard} from "@/app/utils/request/requestList";
import { useMyContext } from "@/app/utils/MyContext";
import { useParams } from 'next/navigation'
import { LangCode, useLanguage } from "@/app/utils/LanguageContext";
import { MenuTab, RaceNo } from "@/app/utils/class/common/base";
import { meetingStatus } from "@/app/utils/constant/statusSet";
import { Dictionary, groupBy, keyBy, orderBy } from 'lodash';
import { Meeting, Race } from "@/app/utils/class/cms";
import "@/app/style/comm.scss";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import BottomBanner from "../BottomBanner/bottombanner";
import Results from "../RaceDetail/components/Results";
import Loading from '@/app/ui/Common/Loading';
import { RaceSelectorData } from "@/app/ui/Common/RaceSelector";
import { meetingTemplate } from "@/app/utils/constant/template";
import UpcomingRaces from "@/app/ui/UpcomingRaces";
import { TopBanner } from "../TopBanner/banner";

const getDefaultMtgDate = (langCode: LangCode, bizDate?: Date, useOverrideMtg?: boolean, signal?: AbortSignal) => {
  const sourceFormat = dateFormat.cms.date;
  const bizDateForCompare = formattedDate(bizDate, sourceFormat);

  const mtgsQIDSProm = new Promise((resolve, reject) => {
    getHomeBasicInfo(false, signal)
      .then((res: any) => {
        const mtgs = res?.commonMeetings;
        let data: any = { racingSeasonPeriod: { ...res?.racingSeasonPeriod }, mtgs: mtgs, currentMtg: undefined, nearestMtg: undefined };
        const onBizDateMtgs = mtgs?.reduce((acc: any, cur: any) => {
          if (bizDateForCompare === cur.date) {
            acc.push(cur);
          }
          return acc;
        }, []);
        const currentMtg = orderRaceOnBizDateFromQIDS(onBizDateMtgs)?.[0];
        data.currentMtg = {
          date: currentMtg?.date,
          venueCode: currentMtg?.venueCode,
          raceNo: currentMtg?.no,
        };
        data.nearestMtg = {
          date: mtgs?.[0]?.date,
          venueCode: mtgs?.[0]?.venueCode,
          raceNo: mtgs?.[0]?.no,
        };
        console.log('getHomeBasicInfo()', data);
        resolve(data);
      })
      .catch((e: any) => {
        console.log('getDefaultMtgDate() -> mtgsQIDSProm() -> getHomeBasicInfo() err:', e);
        resolve(undefined);
      });
  });

  const mtgsCMSProm = new Promise((resolve, reject) => {
    searchMeetingsInDateRange(langCode, toDayJS(bizDate)?.add(-3, 'month')?.toDate(), toDayJS(bizDate)?.add(3, 'month')?.toDate(), signal)
      .then((res: any) => {
        const mtgs = res?.extendedSearch?.results?.items;
        const orderedMeetings = orderBy(mtgs, ['meeting.meetingDate.date', 'meeting.meetingVenueCode.value']);
        const meetingsOnOrAfterBizDateByDate = groupBy(orderedMeetings?.reduce((acc: any, curr: any) => {
          if (compareDate(curr?.meeting?.meetingDate?.date, bizDateForCompare, "after", true)) {
            acc.push(curr);
          }
          return acc;
        }, []), 'meeting.meetingDate.date');
        const closedMeetingsByDate = groupBy(orderedMeetings?.reduce((acc: any, curr: any) => {
          if (compareDate(curr?.meeting?.meetingDate?.date, bizDateForCompare, "before", false)) {
            acc.push(curr);
          }
          return acc;
        }, []), 'meeting.meetingDate.date');
        const upcomingMtg = orderMtgWithMainRaceFromCMS(Object.values(meetingsOnOrAfterBizDateByDate)?.[0])?.[0];
        const closedMtg = orderMtgWithMainRaceFromCMS(Object.values(closedMeetingsByDate).pop())?.[0];
        const nearestMtg = new Meeting(upcomingMtg || closedMtg);
        let data: any = { mtgsBefore: { ...closedMeetingsByDate }, mtgsAfter: { ...meetingsOnOrAfterBizDateByDate }, nearestMtg: undefined };
        if (mtgs?.length) {
          data.nearestMtg = {
            date: nearestMtg?.meetingDate?.date,
            venueCode: nearestMtg?.venueCodeForSearchParam(),
            raceNo: nearestMtg?.isPresite() ? undefined : (nearestMtg?.mainRace || nearestMtg.races?.[0]?.displayName),
          };
        }
        console.log('searchMeetingsInDateRange()', data, nearestMtg?.mainRace)
        resolve(data);
      })
      .catch((e: any) => {
        console.log('getDefaultMtgDate() -> mtgsCMSProm() -> searchMeetingsInDateRange() err:', e);
        resolve(undefined);
      });
  });

  const overrideMtgProm = new Promise((resolve, reject) => {
    getOverrideRedirectionConfig(langCode, signal)
      .then((res: any) => {
        const config = res?.overrideConfig;
        const isEnable = config?.enable?.boolValue;

        const offlineTime = toDate(config?.offlineDateTime?.value, dateFormat.cms.datetime);
        const onlineTime = toDate(config?.onlineDateTime?.value, dateFormat.cms.datetime);
        const isOnline = onlineTime?.getTime() && offlineTime?.getTime() && withinDate(onlineTime, offlineTime, new Date());

        const isMtg = config?.redirectTo?.targetItem?.template?.id === meetingTemplate.ID;
        const isRace = config?.redirectTo?.targetItem?.template?.id === meetingTemplate.RACES.RACE.ID;
        const isMtgOrRace = isMtg || isRace;

        let data: any = { date: undefined, venueCode: undefined, raceNo: undefined };
        if (isEnable && isOnline && isMtgOrRace) {
          const mtg = new Meeting(isMtg ? config?.redirectTo?.targetItem : config?.redirectTo?.targetItem?.parent?.meeting);
          const mtgRaceNo = mtg?.isPresite() ? undefined : (mtg?.mainRace || mtg.races?.[0]?.displayName);
          data = {
            date: mtg?.meetingDate?.date,
            venueCode: mtg?.venueCodeForSearchParam(),
            raceNo: isRace ? config.redirectTo?.targetItem?.displayName : mtgRaceNo,
          };
        }
        console.log('getOverrideRedirectionConfig()', data, { isEnable: isEnable, isOnline: isOnline, isMtgOrRace: isMtgOrRace });
        resolve(data);
      })
      .catch((e: any) => {
        console.log('getDefaultMtgDate() -> overrideMtgProm() -> getOverrideRedirectionConfig() err:', e);
        resolve(undefined);
      });
  });

  const getDefaultMtg = (cmsMtg: any, qidsMtg: any) => {
    if (!cmsMtg && !qidsMtg) return;
    const nearestMtgDateCMS = toDate(cmsMtg?.date, sourceFormat, true);
    const nearestMtgDateQIDS = toDate(qidsMtg?.date, sourceFormat, true);
    let mtgType;
    if (compareDate(cmsMtg?.date, bizDateForCompare, "before", false)) {
      // upcoming mtg > closed mtg
      mtgType = nearestMtgDateQIDS?.getTime() ? "qids" : "cms"
    } else {
      const nearestMtgDate = minDate(nearestMtgDateQIDS, nearestMtgDateCMS);  // get the smallest one if CMS date is after biz date
      if (qidsMtg?.date === bizDateForCompare) {
        // if QIDS date = biz date, priority: QIDS > CMS 
        mtgType = nearestMtgDate?.getTime() === nearestMtgDateQIDS?.getTime() ? "qids" : (nearestMtgDate?.getTime() === nearestMtgDateCMS?.getTime() ? "cms" : undefined)
      } else {
        // if QIDS date =/= biz date, priority: CMS > QIDS 
        mtgType = nearestMtgDate?.getTime() === nearestMtgDateCMS?.getTime() ? "cms" : (nearestMtgDate?.getTime() === nearestMtgDateQIDS?.getTime() ? "qids" : undefined)
      }
    }
    console.log('getDefaultMtgDate() - getDefaultMtg() - minDate', { bizDate: bizDateForCompare, qids: qidsMtg?.date, cms: cmsMtg?.date, mtgType: mtgType })
    return mtgType === "qids" ? qidsMtg : (mtgType === "cms" ? cmsMtg : undefined)
  }

  const promises = useOverrideMtg ? [mtgsQIDSProm, mtgsCMSProm, overrideMtgProm] : [mtgsQIDSProm, mtgsCMSProm];
  return Promise.all(promises).then((res: any[]) => {
    if (signal?.aborted) return;
    const [dataQIDS, dataCMS, overridedMtg] = res;
    const currentMtg = dataQIDS?.currentMtg
    let defaultMtg = {
      date: undefined,
      venueCode: undefined,
      raceNo: undefined,
    };

    const hasOverridedMtg = overridedMtg?.date && overridedMtg?.venueCode;
    if (useOverrideMtg && hasOverridedMtg) {
      defaultMtg = overridedMtg
    } else {
      // get nearest mtg date after comparing date from CMS & QIDS
      if (currentMtg?.date) {
        defaultMtg = currentMtg
      } else {
        defaultMtg = getDefaultMtg(dataCMS?.nearestMtg, dataQIDS?.nearestMtg)
      }
    }
    console.log('getDefaultMtgDate() - defaultMtg()', defaultMtg);
    return {
      defaultMtg: defaultMtg,
      commonMeetings: dataQIDS?.mtgs,
      cmsMeetingsOnOrAfterBizDateByDate: dataCMS?.mtgsAfter,
    }
  })
    .catch((e: any) => {
      console.log('getDefaultMtgDate() err:', e)
      return
    });
}

const fetchFormGuideData = async (langType: string, t: (key: string, defaultValue?: string) => string, season: string, meetings: IMeeting[], RaceMeetingProfile: any) => {
  return !meetings?.length ? [] as FormGuideData[] : await Promise.all([...Array(meetings?.length + 1)].map(async (_: any, idx: number) => {
    const mt = meetings?.[idx === 0 ? 0 : idx - 1] || undefined;
    const meetingDate = toDate(mt?.meetingDate?.value || '', dateFormat.cms.datetime);
    const meetingDateStr = formattedDate(meetingDate, "YYYYMMDD");
    const meetingVenueCode = mt?.meetingVenueCode?.value || '';
    const meetingCountryName = mt?.countryName?.value || '';
    if (idx === 0) {
      const url = generateFormGuidePdfPath(langType, season, meetingDateStr)
      return {
        name: t("formGuide_all_races"),
        selected: false,
        url: url,
        hasPdf: url ? await isUrlExistedWithContentType(url,'application/pdf') : false,
        waRaceNo: generateAdobeDataRaceNo(meetingDate),
      } as FormGuideData
    }

    const noOfRacesNum = RaceMeetingProfile?.[meetingVenueCode]?.races?.map((r: any) => r.no) || [];
    // if (!noOfRacesNum.length) continue;
    // const noOfRacesNum = !isNaN(Number(mt?.noOfRaces?.value)) ? Number(mt?.noOfRaces?.value) : 0;
    noOfRacesNum.unshift(0);
    return {
      name: meetingVenueCode + " " + meetingCountryName,
      selected: false,
      nextLevel: !noOfRacesNum ? undefined : await Promise.all(noOfRacesNum?.map(async (racesNum: any) => {
        if (racesNum === 0) {
          const url = generateFormGuidePdfPath(langType, season, meetingDateStr, meetingVenueCode);
          return {
            name: t("formGuide_all_meeting_races").replace("{venueCode}", meetingVenueCode),
            selected: false,
            url: url,
            hasPdf: url ? await isUrlExistedWithContentType(url,'application/pdf') : false,
            waRaceNo: generateAdobeDataRaceNo(meetingDate, meetingVenueCode),
          } as FormGuideData
        }
        const raceNo = racesNum
        const url = generateFormGuidePdfPath(langType, season, meetingDateStr, meetingVenueCode, raceNo);
        return {
          name: raceNo.toString(),
          selected: false,
          url: url,
          hasPdf: url ? await isUrlExistedWithContentType(url,'application/pdf') : false,
          waRaceNo: generateAdobeDataRaceNo(meetingDate, meetingVenueCode, raceNo),
        } as FormGuideData
      }))
    }
  }))
};

// *url: /[langCode]/overseas/[menuTab]?RaceDate={YYYYMMDD}&Racecourse={venueCode}&RaceNo={raceNo}&redirect={N/Y}
// !venueCode logic please refer to meeting.venueCodeForSearchParam()
// !! may different with the venueCode display in component
// !!! redirect = N/Y: N => no need handle default landing meeting + race if empty, Y => handle landing page (more case refer to PRJ2555-2131)
// *eg: /en-us/overseas/race-summary
export default function Home(props: any) {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const { state: lang } = useLanguage();
  const { t } = lang;
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const [meetings, setMeetings] = useState<IMeeting[]>([]);
  const { menuTab } = useParams();

  const [clickTipOnly, setClickTipOnly] = useState(true);
  const [showTips1, setShowTips1] = useState(true)
  const [showTips2, setShowTips2] = useState(false)
  const [upComRaceData, setUpComRaceData] = useState(null as any);
  useEffect(() => {
    const tipDismissed = JSON.parse(localStorage.getItem('tipDismissed') || '{}');
    const isTip1Dismissed = tipDismissed.tip1;
    const isTip2Dismissed = tipDismissed.tip2;

    if (isTip1Dismissed) {
      setShowTips1(false);
      if (!isTip2Dismissed) {
        setShowTips2(true);
      } else {
        setClickTipOnly(false);
      }
    }
  }, []); 

  const getNextDayRace = (meetingDate?: Date, qidsMeetings?: IRaceMeetingProfile[], cmsMeetings?: Dictionary<{ meeting: IMeeting }[]>) => {
    if (!meetingDate) return;
    const invalidMtStatus = [meetingStatus.DRAFT, meetingStatus.CLOSED, meetingStatus.ABANDON];
    const from = meetingDate;
    const to = toDayJS(meetingDate)?.add(1, "day")?.toDate();
    const meetings = qidsMeetings?.filter((mt: IRaceMeetingProfile) => mt.status && !invalidMtStatus.includes(mt.status.toUpperCase()) && compareDate(mt.date, formattedDate(from, "YYYY-MM-DD"), "after", false) && compareDate(mt.date, formattedDate(to, "YYYY-MM-DD"), "before", true));
    const matchedMeeting = meetings?.find((mt: IRaceMeetingProfile) => cmsMeetings?.[mt.date || ""]?.some((m: { meeting: IMeeting }) => m.meeting.meetingVenueCode?.value === mt.venueCode));
    return matchedMeeting ? toDate(matchedMeeting?.date, dateFormat.qids.dateWithoutTimezone) : undefined;
  }

  // get query from url
  useEffect(() => {
    const { RaceDate: meetingDate, Racecourse: venueCode, RaceNo: raceNo, redirect, focus, current } = getSearchParams(new URLSearchParams(window.location.search));
    console.log('get query from url', meetingDate);
    const controller = new AbortController();
    const signal = controller.signal;
    let timer: any;
    
    getBusinessDate(signal)
      .then((res) => {
        if (signal.aborted) return;
        const bizDate = toDate(res?.timeOffset?.ts, dateFormat.qids.date);
        const useDefault = !(meetingDate && isValidDate(meetingDate, "YYYYMMDD"));
        
        getDefaultMtgDate(lang.langCode, bizDate, current === 'Y' ? false : true, signal)
          .then((mtgRes: any) => {
            if (signal.aborted) return;
            const { defaultMtg, commonMeetings, cmsMeetingsOnOrAfterBizDateByDate } = mtgRes || {};
            let selectedMeetingDate: Date | undefined;
            let beforeCutoff = false;
            let data;
            
            if (useDefault) {
              selectedMeetingDate = toDate(defaultMtg?.date, dateFormat.cms.date, true) || bizDate;
              beforeCutoff = isBeforeCutoff(selectedMeetingDate);
              data = {
                selectedMeetingDate: selectedMeetingDate,
                selectedMeetingVenueCode: defaultMtg?.venueCode,
                selectedRaceNo: new RaceNo(defaultMtg?.raceNo),
              };
            } else {
              selectedMeetingDate = toDate(meetingDate?.toString(), dateFormat.params, true) || bizDate;
              beforeCutoff = isBeforeCutoff(selectedMeetingDate);
              data = {
                selectedMeetingDate: selectedMeetingDate,
                selectedMeetingVenueCode: venueCode?.toUpperCase(),
                ...(venueCode && { selectedRaceNo: new RaceNo(raceNo) }),
              };
            }
            console.log('route 1');
            setRouting(undefined, { 'RaceDate': formattedDate(data.selectedMeetingDate, "YYYYMMDD"), 'Racecourse': data.selectedMeetingVenueCode, 'RaceNo': data.selectedRaceNo?.toParams(), 'redirect': '', 'current': '' }, myContextState);
            
            myContextDispatch({
              type: "update",
              value: {
                ...data,
                bizDate: bizDate,
                commonMeetings: keyBy(commonMeetings, "venueCode"),
                cmsMeetingsOnOrAfterBizDateByDate: cmsMeetingsOnOrAfterBizDateByDate,
                nextDayRace: getNextDayRace(selectedMeetingDate, commonMeetings, cmsMeetingsOnOrAfterBizDateByDate),
                redirectPageOnLand: redirect?.toUpperCase() === 'Y' || useDefault,
                redirectMtgOrRaceIfEmptyOnLand: redirect?.toUpperCase() === 'N' ? false : true,
                calendarDateSelected: focus?.toUpperCase() === "Y" ? true : false,
                menuTab: new MenuTab(beforeCutoff ? menuTabSet.RESULTS : (menuTab?.toString() ?? "")),
                dataSource: beforeCutoff ? "qids" : "both",
              }
            });
          });
      });
  }, [])

  const getUpcomingFn = (elapsed?: any) => {
    // console.log("elapsed----", elapsed)
    const controller = new AbortController();
    const signal = controller.signal;
    getBusinessDate(signal)
    .then((res) => {
      if (signal.aborted) return
      // fix bizdate empty issue
      if (res) {
        getupcomingRacecard(lang.langCode, res, t, signal).then((res2: any) => {
          if (signal.aborted) return
            setUpComRaceData(res2);
            myContextDispatch({
              type: "update", value: { upComRaceData: res2 }
            });
          });
      } else {
        setUpComRaceData({
          _None: true
        } as any);
      }
    });
  }
  useInterval(getUpcomingFn);
  // get most update upcoming race data
  useEffect(() => {
    const controller = new AbortController();
    getUpcomingFn();
    // Fixed: Named function handler to allow clean removal
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        getUpcomingFn();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // Store reference dynamically for teardown scope block closure
    (controller as any)._visibilityHandler = handleVisibilityChange;
    return () => {
      controller.abort('home -> abort query');
      if ((controller as any)._visibilityHandler) {
        document.removeEventListener('visibilitychange', (controller as any)._visibilityHandler);
      }
    };
  }, [])
  // get meeting data + handle default landing
  useEffect(() => {
    console.log('hook dependency check: get meeting data', myContextState.selectedMeetingDate);
    if (myContextState.selectedMeetingDate?.getTime() === new Date(0)?.getTime() || myContextState.dataSource !== "both") return;
    console.log('get meeting data');
    const controller = new AbortController();
    const signal = controller.signal;
    searchMeetingsByDate(lang.langCode, myContextState.selectedMeetingDate, signal)
      .then((res: any) => {
        if (signal.aborted) return
        const newMeetings = orderBy(res?.search?.results?.items?.map((x: any) => x.meeting), ['meetingVenueCode.value'])
        const countryNameList = res?.search?.results?.items;
        if (newMeetings?.length === 0) {
          console.log('route 0');
          const defaultMenuTab = getDefaultMenuTab();
          setRouting(myContextState.redirectPageOnLand ? `/${encodeURIComponent(defaultMenuTab.valueOf())}` : undefined, { 'RaceDate': formattedDate(myContextState.selectedMeetingDate, "YYYYMMDD"), 'Racecourse': '', 'RaceNo': '', 'redirect': '' }, myContextState);
          myContextDispatch({
            type: "update", value: {
              selectedMeeting: undefined,
              selectedRace: undefined,
              selectedMeetingVenueCode: "",
              selectedRaceNo: new RaceNo(''),
              isLoadingMeetings: false,
              isLoadingRaces: false,
              isChangingMeeting: false,
              ...(myContextState.redirectPageOnLand && { menuTab: defaultMenuTab }),
            }
          });
          return
        } else {
          const season = newMeetings[0]?.season?.name || '';
          // PRJ2555-2131: if any meetings have main race -> main race of the meeting (get smaller venue code if multiple meeting w/ main race), if no meeting have main race -> first race of the smallest meeting
          const defaultMtg = new Meeting(myContextState.redirectMtgOrRaceIfEmptyOnLand ? orderMtgWithMainRaceFromCMS(newMeetings)?.[0] : newMeetings?.[0]);
          const isMtgExisted = newMeetings.some((mtg) => new Meeting(mtg).venueCodeForSearchParam() === myContextState.selectedMeetingVenueCode);
          const useDefaultMtg = !myContextState.selectedMeetingVenueCode || !isMtgExisted;
          let defaultVenueCode = defaultMtg.venueCodeForSearchParam();
          const callback = () => {
            let overridedDataForDefaultMtg: any;
            console.log('is venue code existed?', isMtgExisted)
            console.log('default meeting landing:', defaultVenueCode)
            getMeetingStatus(myContextState.selectedMeetingDate, "", signal) // get all meetings in that date
              .then(async (res: any) => {
                if (signal.aborted) return;
                const RaceMeetingProfile = keyBy(res?.raceMeetingProfile, 'venueCode');
                fetchFormGuideData(lang.langType, t, season, newMeetings, RaceMeetingProfile)
                  .then((formGuides: FormGuideData[]) => {
                    if (signal.aborted) return;
                    newMeetings.forEach((mt: IMeeting) => {
                      mt.RaceMeetingProfile = RaceMeetingProfile[mt.meetingVenueCode?.value?.toUpperCase() || '']
                      const _countryNm = countryNameList?.find((x:any)=>x?.meeting?.id === mt?.id)?.meeting?.countryName;
                      const _countryNm_cp = Object.assign({}, _countryNm);
                      const _cValue = _countryNm.value?.replaceAll(" ", "")?.toUpperCase();
                      const _cCode = (_cValue && t(`ContryCode_${_cValue}`).indexOf("ContryCode_") == -1 && t(`ContryCode_${_cValue}`) ) || ""
                      _countryNm.value = _cCode;
                      mt.countryNameEn = _countryNm;
                      mt.countryName = _countryNm_cp;
                  });
                    if (useDefaultMtg) {
                      console.log('route 4 - default mtg');
                      const redirectPage = useDefaultMtg;
                      setRouting(undefined, { 'Racecourse': defaultVenueCode, 'RaceNo': '' }, myContextState);
                      overridedDataForDefaultMtg = {
                        selectedMeetingVenueCode: defaultVenueCode,
                        selectedRaceNo: new RaceNo(0),
                        redirectPageOnLand: redirectPage,
                      }
                    }
                    setMeetings(newMeetings);
                    myContextDispatch({
                      type: "update", value: {
                        formGuides: formGuides,
                        season: season,
                        isLoadingMeetings: false,
                        isChangingMeeting: true,
                        ...overridedDataForDefaultMtg,
                        ...(newMeetings.length === 0 && { isLoadingRaces: false, isChangingMeeting: false }),
                      }
                    });
                  })
                  .catch((e: any) => {
                    console.log(e)
                  });
              })
              .catch((e: any) => {
                console.log(e);
              });
          }
          if (useDefaultMtg && myContextState?.bizDate?.getTime() === myContextState.selectedMeetingDate?.getTime()) {
            // call defaultMtg api
            getDefaultMtgDate(lang.langCode, myContextState.bizDate, false, signal)
              .then((mtgRes: any) => {
                if (signal.aborted) return
                const { defaultMtg } = mtgRes || {};
                defaultVenueCode = defaultMtg?.venueCode
                callback();
              })
              .catch((e: any) => {
                callback();
              });
          } else {
            callback();
          }
        }
      });
    return () => {
      controller.abort('home -> abort getMeetingInfo: myContextState.selectedMeetingDate updated');
    }
  }, [myContextState.selectedMeetingDate, myContextState.dataSource])

  // generic handling - change meeting
  useEffect(() => {
    console.log('hook dependency check: generic handling - change meeting', meetings, myContextState.isLoadingMeetings, myContextState.isChangingMeeting);
    if (myContextState.dataSource !== "both") return;
    if (myContextState.selectedMeetingDate?.getTime() === new Date(0)?.getTime()) return;
    if (myContextState.isLoadingMeetings) return;
    if (!myContextState.isChangingMeeting) return; // reduce repeated call when switching meeting
    if (meetings.length === 0) return;
    if (!window.location.search) return;
    
    const { Racecourse, RaceNo: urlRaceNo } = getSearchParams(new URLSearchParams(window.location.search));
    const venueCode = Racecourse || new Meeting(orderMtgWithMainRaceFromCMS(meetings)?.[0])?.venueCodeForSearchParam(); // use url venueCode / default venueCode
    const raceNo = new RaceNo(urlRaceNo);
    console.log('generic handling - change meeting',Racecourse, venueCode );
    const controller = new AbortController();
    const signal = controller.signal;

    // find meeting matched with url query
    const selectedMeetingIdx = meetings?.findIndex((mt: IMeeting) => new Meeting(mt).isMatchWithVenueCode(venueCode))
    let selectedMeeting = new Meeting(meetings[selectedMeetingIdx === -1 ? 0 : selectedMeetingIdx]);
    console.log('check selectedMeeting here', selectedMeeting, meetings[selectedMeetingIdx === -1 ? 0 : selectedMeetingIdx])
    getSelectedMeetingInfo(lang.langCode, myContextState.season, selectedMeeting?.displayName, signal)
      .then((res: any) => {
        console.log(`route check: raceNo - ${raceNo}`);
        // add status check to prevent data overrided by incorrect data when api is aborted
        if (signal.aborted) return;
        selectedMeeting.setRaces(res?.item?.races);
        const races = selectedMeeting.races || [];

        // feat: PRJ2555-1329 When customer has landed new site and switch to another meeting, redirect to corresponding page of the first race of that meeting
        const raceNoHanlder = (calculatedRaceNo: RaceNo, menuTab: MenuTab, defalutRaceNo?: RaceNo) => {
          if (signal.aborted) return;
          // feat: PRJ2555-1329 part 1/2, default landing page
          console.log('route: redirect landing page?', myContextState.redirectPageOnLand)
          // check if raceNo existed in sitecore, if not, set to default / 0
          const selectedRaceIdx = races ? races?.findIndex((r: IRace) => calculatedRaceNo.isEqual(r.displayName)) : -1;
          const raceNo = (selectedRaceIdx !== -1) ? calculatedRaceNo : (defalutRaceNo || new RaceNo(0));
          console.log('route 2');
          setRouting(myContextState.redirectPageOnLand ? `/${encodeURIComponent(menuTab.valueOf())}` : undefined, { 'Racecourse': selectedMeeting?.venueCodeForSearchParam(), 'RaceNo': raceNo?.toParams(), 'redirect': '' }, myContextState);
             
          myContextDispatch({
            type: "update", value: {
              isChangingMeeting: false,
              isLoadingRaces: false,
              selectedMeeting: selectedMeeting,
              selectedMeetingVenueCode: selectedMeeting.meetingVenueCode?.toUpperCase(),
              selectedRaceNo: raceNo,
              defaultRaceNo: defalutRaceNo ? defalutRaceNo : raceNo,
              selectedRace: selectedRaceIdx === -1 ? undefined : new Race(races[selectedRaceIdx]),
              // feat: PRJ2555-1329 only need to apply on user landed from fixture item/header; or menu item is not existed after meeting change
              redirectPageOnLand: false,
              redirectMtgOrRaceIfEmptyOnLand: false, // feat: PRJ2555-2131
              ...(myContextState.redirectPageOnLand && { menuTab: menuTab }),
            }
          })
        }

        // feat: PRJ2555-1018 + PRJ2555-1926
        const handleDefaultRaceNo = () => {
          if (signal.aborted) return;
          const defaultMenuTab = getDefaultMenuTab(myContextState.bizDate, selectedMeeting);
          // For pre-site handling, display pre-site meeting page instead of race as they are not defined yet
          if (selectedMeeting?.isPresite()) {
            raceNoHanlder(new RaceNo(races?.[0]?.displayName || 0), defaultMenuTab);
          } else {
            // get default race no if race no data is not describe in url query:
            // - Before raceday: main race of the smallest venue code (from sitecore) / first race of the smallest venue code
            // - On raceday: first race of the smallest venue code: raceday date = biz date
            // - During raceday: current race of the current meeting: status ordering - Started/upcoming > finished
            // - Raceday all meetings finished: last race of the largest venue code: meeting status = ABANDON | ABANDON_PARTIAL | CLOSED
            // - After raceday: same with "Before raceday":  raceday date != biz date & meeting status != STARTED
            const onRaceday = formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD") === formattedDate(myContextState.bizDate, "YYYY-MM-DD");
            const defalutRaceNo = new RaceNo(races[0]?.displayName || 1); // for providing default race no switching page from query with `raceNo=All` if applicable

            let calRaceNo: string | number | undefined;
            switch (true) {
              case onRaceday: // On raceday / During raceday
                const currentUpcomingRaces = orderRaceOnBizDateFromQIDS([selectedMeeting?.RaceMeetingProfile || {}]);
                console.log('on raceday', selectedMeeting?.RaceMeetingProfile, currentUpcomingRaces)
                calRaceNo = currentUpcomingRaces[0]?.no || races.length && races[races.length - 1]?.displayName || 1;
                console.log('on raceday - cal race no:', calRaceNo)
                // PRJ2555-2131: invalid race no handling
                if (!new RaceNo(calRaceNo).isExistedInCMS(races)) {
                  console.log('on raceday - cal race no not existed, use default:', defalutRaceNo.valueOf())
                  calRaceNo = defalutRaceNo.valueOf();
                }
                break;
              default: // Before/After raceday
                calRaceNo = selectedMeeting?.mainRace || races[0]?.displayName || 1;
                console.log('before/after raceday - cal race no:', calRaceNo)
                break;
            } 
            // if contains raceNo in query -> only redirect page
            // if x contains raceNo in query -> redirect page + raceNo
            switch (true) {
              // get default race no from url query, check if it is valid
              case raceNo.isValid(myContextState.menuTab) && raceNo.isExistedInCMS(races):
                console.log('racingInfo -> query race no', raceNo?.toParams());
                raceNoHanlder(raceNo, defaultMenuTab, defalutRaceNo);
                break;
              // get first race of the meeting
              case !myContextState.redirectMtgOrRaceIfEmptyOnLand:
                console.log('racingInfo -> first race no', races[0]?.displayName);
                raceNoHanlder(new RaceNo(calRaceNo), defaultMenuTab, defalutRaceNo);
                break;
              default:
                console.log('racingInfo -> active race no (redirect race)', calRaceNo);
                raceNoHanlder(new RaceNo(calRaceNo || 0), defaultMenuTab, defalutRaceNo);
                break;
            }
          }
        }

        // get latest data
        getMeetingStatus(myContextState.selectedMeetingDate, selectedMeeting?.meetingVenueCode || '', signal)
          .then((res: any) => {
            if (signal.aborted) return;
            if (res?.raceMeetingProfile?.[0]) {
              selectedMeeting.RaceMeetingProfile = res?.raceMeetingProfile?.[0];
            }
          })
          .catch((e) => {
            if (signal.aborted) return;
            console.log(e);
          })
          .finally(() => {
            if (signal.aborted) return;
            handleDefaultRaceNo();
          })
      })
      .catch((e: any) => {
        console.log(e);
      });

    return () => {
      controller.abort('racingInfo -> abort getSelectedMeetingInfo: meetings/tabIdx changed');
    }
  }, [meetings, myContextState.isLoadingMeetings, myContextState.isChangingMeeting, myContextState.dataSource])

  // generic handling - change race no
  useEffect(() => {
    console.log('hook dependency check: generic handling - change race no', myContextState.isLoadingRaces, myContextState.selectedRaceNo);
    if (myContextState.dataSource !== "both") return;
    if (myContextState.selectedMeetingDate?.getTime() === new Date(0)?.getTime()) return;
    if (myContextState.isLoadingRaces || meetings.length === 0) return
    console.log('generic handling - change race no');
    const races = myContextState.selectedMeeting?.races
    const selectedRaceIdx = races ? races?.findIndex((r: IRace) => myContextState.selectedRaceNo.isEqual(r.displayName)) : -1;
    console.log('route 3')
    setRouting(undefined, { 'RaceNo': myContextState.selectedRaceNo?.toParams() }, myContextState);
    const matchedItem = selectedRaceIdx === -1 ? undefined : myContextState.formGuides?.find((d) => myContextState.selectedMeeting?.meetingVenueCode?.toUpperCase() === d.name.toUpperCase())?.nextLevel?.find((subD) => (myContextState.selectedRaceNo).toString() == subD.name);
    myContextDispatch({
      type: "update", value: {
        selectedRace: (selectedRaceIdx !== -1 && races && races.length > 0 && races[selectedRaceIdx]) ? new Race(races[selectedRaceIdx]) : undefined,
        selectedRaceFormGuideUrl: matchedItem?.hasPdf ? matchedItem.url : undefined,
      }
    })
  }, [myContextState.isLoadingRaces, myContextState.selectedRaceNo, myContextState.dataSource]);

  // special hanlding - historial results
  useEffect(() => {
    if (myContextState.selectedMeetingDate?.getTime() === new Date(0)?.getTime() || myContextState.dataSource !== "qids") return;
    const controller = new AbortController();
    const signal = controller.signal;
    getMeetingStatus(myContextState.selectedMeetingDate, undefined, signal)
      .then((res: any) => {
        const data = res?.raceMeetingProfile?.reduce((acc: RaceSelectorData, cur: any) => {
          const venueCode = cur?.venueCode || '';
          if (!acc[venueCode]) {
            acc[venueCode] = { races: [] };
          }
          acc[venueCode].races.push(...(cur?.races?.map((r: any) => r.no) || []));
          return acc;
        }, {})
        // fill default meeting & race no for historical results page
        const firstVenueCode = Object.keys(data)?.[0];
        const firstRaceNo = data?.[firstVenueCode]?.races?.[0];
        myContextDispatch({
          type: "update", value: {
            menuTab: new MenuTab(menuTabSet.RESULTS),
            raceSelectorData: data,
            isLoadingMeetings: false,
            isLoadingRaces: false,
            ...(firstVenueCode && !myContextState.selectedMeetingVenueCode && { selectedMeetingVenueCode: firstVenueCode }),
            ...(firstRaceNo && !myContextState.selectedRaceNo.valueOf() && { selectedRaceNo: new RaceNo(firstRaceNo) }),
          }
        })
      })
      .catch((e: any) => {
        myContextDispatch({
          type: "update", value: {
            menuTab: new MenuTab(menuTabSet.RESULTS),
            isLoadingMeetings: false,
            isLoadingRaces: false
          }
        })
        console.log(e);
      });
    return () => {
      controller.abort('home -> abort getMeetingStatus: myContextState.selectedMeetingDate updated');
    }
  }, [myContextState.selectedMeetingDate, myContextState.dataSource])

  useEffect(() => {
    if (myContextState.dataSource === "qids") {
      console.log('qids - route 1')
      setRouting(`/${encodeURIComponent(new MenuTab(menuTabSet.RESULTS).valueOf())}`, { 'Racecourse': myContextState.selectedMeetingVenueCode }, myContextState);
      return;
    }
  }, [myContextState.selectedMeetingVenueCode, myContextState.dataSource])

  useEffect(() => {
    if (myContextState.dataSource === "qids") {
      console.log('qids - route 2')
      setRouting(undefined, { 'RaceNo': myContextState.selectedRaceNo?.toParams() }, myContextState);
      return;
    }
  }, [myContextState.selectedRaceNo, myContextState.dataSource])

  // handle meta tag on page change
  useEffect(() => {
    if (!myContextState.menuTab.toString()) return;
    updateMetaTag(lang.langCode, myContextState.menuTab.toString())
  }, [myContextState.menuTab])

  useEffect(() => {
    const handleClickBack = (e: any) => {
      const { RaceDate: date, Racecourse: venueCode, RaceNo: raceNo } = getSearchParams(new URLSearchParams(window.location.search));
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split("/");
      if (raceNo) {
        if (myContextState.selectedMeetingVenueCode != venueCode)//change meeting
        {
          console.log("Back_ContextState1", myContextState.selectedMeetingVenueCode, venueCode);
          myContextDispatch({
            type: "update", value: {
              isLoadingRaces: true,
              isChangingMeeting: true
            }
          })
        }
        else if (myContextState.selectedRaceNo.toString() != (raceNo?.toLowerCase() == 'all' ? '-1' : raceNo))//change race
        {
          console.log("Back_ContextState2", myContextState.selectedRaceNo, raceNo);
          if (myContextState.menuTab?.toString() != pathParts[pathParts.length - 1]?.toString()) {
            myContextDispatch({
              type: "update",
              value: {
                selectedRaceNo: new RaceNo(raceNo),
                menuTab: new MenuTab(pathParts[pathParts.length - 1]?.toString())
              }
            });
          } else {
            myContextDispatch({
              type: "update",
              value: {
                selectedRaceNo: new RaceNo(raceNo)
              }
            });
          }
        }
        else// if(myContextState.menuTab?.toString()!=pathParts[pathParts.length-1]?.toString())//change page
        {
          console.log("Back_ContextState3", myContextState.menuTab, pathParts[pathParts.length - 1]?.toString());
          myContextDispatch({
            type: "update",
            value: { menuTab: new MenuTab(pathParts[pathParts.length - 1]?.toString()) }
          });
        }
      } else {
        window.history?.back();
      }
    }
    window.addEventListener("popstate", handleClickBack);
    return () => {
      window.removeEventListener("popstate", handleClickBack);
    };
  }, [myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo, myContextState.menuTab])

  const handleTip1Dismiss = () => { 
    setShowTips1(false)
    setShowTips2(true)
  }

  useEffect(() => {
    if (!showTips2 || myContextState.isLoadingRaces) return;
    if (myContextState.selectedMeeting?.isPresite()) {
      if (clickTipOnly) {
        handleTip2Dismiss();
      }
    } else {
      setClickTipOnly(true);
    }
  }, [showTips2, myContextState.isLoadingRaces, myContextState.selectedMeeting])

  const handleTip2Dismiss = () => {
    setShowTips2(false)
    setClickTipOnly(false);
    document.querySelector('div:first-child')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  useEffect(() => {  
    if(upComRaceData?._None && showTips1){ 
      handleTip1Dismiss() 
    }  
  },[upComRaceData])


  const renderContent = () => {
    return isMobile ? (
      <Box sx={{ display: { lg: "none" }, padding: "5px 8px", width: "100%"}}>
        {
        // myContextState.selectedMeeting?.presite ||
        upComRaceData?._None ?
          <><Box id="racingHeaderContainer" style={{ marginBottom: 12}} >
            <RacingHeader meetings={meetings} />
          </Box>
            {/* <Box id="broadcastSectionContainer" style={{ padding: "8px 0" }}>
              <Broadcast />
            </Box> */}
            </> : <><UpcomingRaces type="mobile" clickTipOnly={clickTipOnly} upComRaceData={upComRaceData} showTips1={showTips1} onTips1Dismiss={handleTip1Dismiss}/></>
        }
        
        {/* <Box id="racingInfoContainer" >
          <RacingInfo showTips1={showTips1} onTips1Dismiss={handleTip1Dismiss} meetings={meetings} setRacesDetailLoading={setRacesDetailLoading} />
        </Box>     */}
        <RaceDetail clickTipOnly={clickTipOnly} showTips2={showTips2} onTips2Dismiss={handleTip2Dismiss} isMobile meetings={meetings} setRacesDetailLoading={setRacesDetailLoading} isLoadingRacesDetail={isLoadingRacesDetail} />
      </Box>
    ) : (
      <>
        
        {
          // myContextState.selectedMeeting?.presite|| 
          upComRaceData?._None ?
            <Box id="meetingAndRaceContainer" sx={{ display: { xs: "none", lg: "block" }, padding: "5px 0px", width: "100%" }}>

              <><div style={{
                background: "white", borderRadius: "5px", boxShadow: "0px 2px 10px 0px #0000001A"
              }}>
                <RacingHeader meetings={meetings} />
                <Box
                  sx={{ margin: "0 10px" }}
                ></Box>
                {/* <Broadcast /> */}
              </div>
                <div style={{ padding: "10px" }}></div>
              </>
              {/* <RacingInfo meetings={meetings} setRacesDetailLoading={setRacesDetailLoading} /> */}
            </Box>
            :
            <><UpcomingRaces type="pc" upComRaceData={upComRaceData}/></>
        }
        <RaceDetail meetings={meetings} setRacesDetailLoading={setRacesDetailLoading} isLoadingRacesDetail={isLoadingRacesDetail} />
      </>
    )
  }

  const [isLoadingRacesDetail, setRacesDetailLoading] = useState(true);

  const renderer = () => {
    switch (myContextState.dataSource) {
      case "both":
        return renderContent()
      case "qids":
        return <Results type={isMobile ? "mobile" : "pc"}
          dataSource={myContextState.dataSource}
          isLoadingRacesDetail={isLoadingRacesDetail}
          setRacesDetailLoading={setRacesDetailLoading} />
    }
  }

  return (
    <>
      {
        myContextState.isLoadingMeetings ? <Loading /> : <main className={`${styles.main}${isMobile && clickTipOnly && !myContextState.isLoadingMeetings && meetings.length ? ' clickTipOnly' : ''}`}>
          <Header />
          <HeaderNav />
          <TopBanner isMobile={isMobile} />
          <div className="commBContent" style={{ padding: isMobile ? "" : "0 16px" }}>
            {renderer()}
            {myContextState.dataSource !== "qids" && <BottomBanner />}
          </div>
          <Footer />
        </main>
      }
    </>
  );
}
